import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'app-base-input',
  standalone: true,
  imports: [CommonModule, FormsModule],  // ← add FormsModule here
  templateUrl: './base-input.component.html',
  styleUrl: './base-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BaseInputComponent),
      multi: true
    }
  ]
})
export class BaseInputComponent implements ControlValueAccessor {
  @Input() id?: string;
  @Input() name?: string;          
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() value = '';
  @Input() autocomplete?: string;
  @Input() ariaLabel?: string;
  @Input() maxlength?: number;
  @Input() isFluid = false;
  @Input() disabled = false;
  @Input() mt = '';
  @Input() mb = '';

  @Output() focusEvent = new EventEmitter<FocusEvent>();
  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() valueChange = new EventEmitter<string>();
  @Output() onEnter = new EventEmitter<void>();

  private onChange: (v: any) => void = () => {};
  private onTouched: () => void = () => {};

  onInput(event: Event) {
    const newValue = (event.target as HTMLInputElement).value;
    this.value = newValue;
    this.onChange(newValue);
    this.valueChange.emit(newValue);
  }

  handleFocus(event: FocusEvent) {
    this.focusEvent.emit(event);
  }

  handleBlur(event: FocusEvent) {
    this.onTouched();
    this.blurEvent.emit(event);
  }

  handleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onEnter.emit();
    }
  }

  writeValue(obj: any): void { this.value = obj ?? ''; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void { this.disabled = isDisabled; }
}
